import { palette } from './palette';

export const homeStyle = {
  '.killeen-container': {
    /* Header - styles */
    '& .header-wrapper': {
      background: palette.alternate.main,

      '& .MuiToolbar-root': {
        '@media(min-width: 600px) and (max-width: 899px)': {
          padding: '0 8px',
        },
      },
    },
    '& .active-header': {
      boxShadow: '2px 1px 7px rgba(0, 0, 0, 0.2)',
    },

    /* Hero Section - Styles */
    '& .home-hero-wrapper': {
      position: 'relative',
      margin: '0 auto',
      padding: 0,
      background: palette.alternate.main,

      '& .hero-section': {
        padding: '0px 12px',

        '@media(min-width: 900px)': {
          padding: '0 0 0 80px',
        },
      },
      '& .section-alternate__content': {
        '@media(min-width: 900px)': {
          padding: '0 0 0 48px',
        },
      },
      '& .hero-section-alternate': {
        height: 'auto !important',
        paddingBottom: 0,
      },
      '& .hero-subtitle': {
        maxWidth: 475,
      },
      '& .normal-text': {
        fontWeight: 400,
        fontSize: 55,
      },
      '& .image-wrapper': {
        position: 'relative',
        padding: 0,
        '& .image': {
          boxShadow: 'none',
        },
      },
    },

    /* Benefits - Styles */
    '& #definition-section': {
      '& .benefits-wrapper': {
        padding: '0 24px',

        '@media(min-width: 900px)': {
          padding: '0 48px',
        },
      },
      '& .service-tile-wrapper-0': {
        display: 'flex',
      },
      '& .service-tile-wrapper-1': {
        marginBottom: '40px',
      },
      '& .service-tile-wrapper-2': {
        paddingBottom: '40px',
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      '& .subscription-bg': {
        height: '50%',
        maxHeight: 525,
      },
      '& #pricing-benefit-section': {
        paddingBottom: 48,

        '& .subscription-section': {
          paddingTop: 80,

          '& .section-header__subtitle': {
            maxWidth: 725,
            margin: '0 auto',
          },
        },
        '& .planCard': {
          '&:hover': {
            background: palette.primary.contrastText,
            color: palette.text.primary,

            '& .description-cta p': {
              color: palette.text.primary,
            },
          },
          '& .highlight-divider': {
            backgroundColor: palette.text.disabled,
          },
        },
        '& .savings-summary-link': {
          cursor: 'pointer',
          textDecoration: 'underline',
        },
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      '& .step-counter': {
        width: 60,
        height: 60,
        borderRadius: 8,
        background: palette.background.alternate,
        color: palette.text.primary,
      },
    },

    /* Testimonial - Styles */
    '& .testimonial-wrapper': {
      '@media(min-width: 900px)': {
        padding: 72,
      },

      '& .testimonialSection': {
        padding: '40px 32px',

        '@media(min-width: 900px)': {
          padding: '40px 16px',
        },
        '& .testimonial-container': {
          justifyContent: 'center',

          '& .testimonial-message': {
            fontSize: 32,
            lineHeight: 1.25,
            fontWeight: 500,
          },
          '& .testimonial-name': {
            color: palette.text.primary,
          },
        },
      },
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .savings-hero-section': {
        height: 303,
        backgroundColor: 'unset',
        background: `url('./images/saving_summary.webp') no-repeat center`,
        backgroundSize: 'cover',
      },
      '& .savings-topheader': {
        color: `${palette.primary.contrastText} !important`,
      },
    },

    '& .faq-hero-section': {
      height: 303,
      backgroundColor: 'unset',
      background: `url('./images/faq.webp') no-repeat center`,
      backgroundSize: 'cover',
    },

    '& .faq-contact-wrapper': {
      '& .section-header__subtitle-wrapper p': {
        maxWidth: 600,
      },
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0,
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      },
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },
  },
};
